import { render } from "./ReplyForm.vue?vue&type=template&id=4b3b438a"
import script from "./ReplyForm.vue?vue&type=script&lang=js"
export * from "./ReplyForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__